import Vue from 'vue';
import Vuex from 'vuex';

import login from './module/login';
import sideMenu from "./module/sideMenu";
import system from './module/system/index'
import msg from './module/msg/index';
import order from './module/order/index';
import purchase from './module/purchase/index'
import send from './module/send/index'
import bill from './module/bill/index'

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        sideMenu,
        login,
        system,
        msg,
        order,
        purchase,
        send,
        bill
    }
});